// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

'use strict';

import Vue from 'vue'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

Raven.config('https://f6ef4b0e0e8a471bad155a93e66b6188@sentry.io/117338')
  .addPlugin(RavenVue, Vue)
  .install();

import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate';

import './assets/css/style.css'

import {
  isEligible
} from './modules/session'
import Validators from './modules/validators'
import tools from './plugins/toolbox'

import App from './App'
import routes from './routes'



// Load polyfills

if (browserSupportsAllFeatures()) {
  // Browsers that support all features run `main()` immediately.
  main();
} else {
  // All other browsers loads polyfills and then run `main()`.
//
  loadScript();
}

function main() {
  // Initiate all other code paths.
  // If there's an error loading the polyfills, handle that
  // case gracefully and track that the error occurred.


Vue.use(VueRouter)
Vue.use(VeeValidate);
Validators(VeeValidate.Validator)
Vue.use(tools)

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
 NProgress.start();
  if (to.name === 'home' && !router.app.$isTokenExpired()) {
    switch (router.app.$getUser().role) {
      case router.app.$userRoles.admin:
        next({
          name: 'admin.customers'
        })
        break
      case router.app.$userRoles.customer:
        next({
          name: 'customer.dashboard'
        })
        break
      case router.app.$userRoles.courier:
          next({
          name: 'courier.customers'
        })
        break
    }
  } else {
    if (isEligible(to.meta.role)) {
      next()
    } else {
      next('restrict')
    }
  }

})

router.afterEach((to, from) => {
  NProgress.done();
})

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')





}

function browserSupportsAllFeatures() {
  return window.Promise && window.fetch && window.Symbol && Array.from;
}

function loadScript() {
  let js = document.createElement('script');
let src = "https://cdn.polyfill.io/v2/polyfill.min.js?features=Promise,fetch,Symbol,Array.from,Array.prototype.@@iterator"

  js.src = src;
  js.onload = function(done) {
    main();
  };
  js.onerror = function() {
    //done(new Error('Failed to load pollyfill script ' + src));
    throw new Error('Failed to load pollyfill script ' + src)
  };
  document.head.appendChild(js);
}

// https://philipwalton.com/articles/loading-polyfills-only-when-needed/










/*new Vue({
  el: '#app',
  render: h => h(App)
})*/





// WEBPACK FOOTER //
// ./src/main.js